import { useHistory, useLocation } from "react-router-dom";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

// ユーザー配信のコンテンツ種別タブ。
// 後々「log build からのお知らせ」等の配信を増やす前提で、
// 種別ごとに /logbuild/delivery/* のルートとタブをここへ追加する。
// 例: { label: "お知らせ", path: "/logbuild/delivery/notices" }
const deliveryTabs = [{ label: "マニュアル", path: "/logbuild/delivery/manuals" }];

const DeliveryTabs = () => {
  const history = useHistory();
  const location = useLocation();
  const currentIndex = deliveryTabs.findIndex(
    tab => tab.path === location.pathname
  );

  return (
    <Tabs
      value={currentIndex === -1 ? 0 : currentIndex}
      onChange={(_, index) => history.push(deliveryTabs[index].path)}
      indicatorColor="primary"
      textColor="primary"
      className="mb-5"
    >
      {deliveryTabs.map(tab => (
        <Tab key={tab.path} label={tab.label} />
      ))}
    </Tabs>
  );
};

export default DeliveryTabs;
